import { Serializer } from 'src/app/core/common/http/serializer';
import { AreaIgatewayResource, } from './area-igateway.resource';
import { AreaIGatewayModel } from '../model/area-igateway.model';

export class AreaIGatewaySerializer implements Serializer { 
  fromJson(json: any): AreaIgatewayResource { 
    const resource = new AreaIgatewayResource();

    resource.notes = json.notes;
    resource.equivalent_profile_user = json.equivalent_profile_user;

    return resource;
  }

  toJson(model: AreaIGatewayModel): any  {
    const resource = new AreaIgatewayResource();
    
    resource.notes = model.notes;
    resource.equivalent_profile_user = model.equivalent_profile_user;

    return resource;
  }
}